<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  mounted() {
    if(window.location.host!='service.jsyalian.cn' && window.location.host!='192.168.10.80:88'){
      document.querySelector(".app-main").style.background = "#65A281"
    }else{
      document.querySelector(".app-main").style.background = "#f4f4f4"
    }

  }
}
</script>

<style lang="scss" scoped>
/* fixed-header=84  */
.app-main {
  min-height: 100vh;
  width: 100%;
  position: relative;
  overflow-y: scroll;
  padding: 20px;
  //background: #f4f4f4;
  //background: #65A281;
  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }
}

.fixed-header+.app-main {
  padding-top: 104px;
}
.app-main>div{
  padding: 15px;
  background:#fff;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue